// packages/web/src/api/user-replacements/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { userReplacementsList, userReplacementsGet } from "../generated/sdk.gen.ts";
import { queryKeys } from "../query-keys.ts";

export const userReplacementsListOptions = () =>
  queryOptions({
    queryKey: queryKeys.userReplacements.list(),
    queryFn: async () => {
      const { data, error } = await userReplacementsList();
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });

export const userReplacementsByIdOptions = (id: string) =>
  queryOptions({
    queryKey: queryKeys.userReplacements.byId(id),
    queryFn: async () => {
      const { data, error } = await userReplacementsGet({ path: { id } });
      if (error) throw error;
      return data;
    },
    enabled: !!id,
    staleTime: 30_000,
  });
